import React from "react";
import { useTracking } from "../../hooks/useTracking";

import ImgEmpezar from "../../assets/Page_2/Illustration2.svg";
import ImgTest from "../../assets/Page_2//Icon_Tests.svg";
import ImgSintomas from "../../assets/Page_2/Icon_Identifying.svg";

import "./SectionEmpezar.css";
import Card from "../Card/Card";
import Button from "../Button/Button";


const SectionEmpezar = () => {
  const { trackEvent } = useTracking();
  const handleAgendarCitaClick = () => {
    trackEvent("agendar_cita_click", {
      ubicacion: "section_empezar",
    });

    window.open("https://www.apec.org.mx/citas", "_blank", "noopener,noreferrer");
  };
  return (
    <section className="section-empezar">
      <h1 className="title-empezar">¿Cómo prefieres empezar?</h1>
      <img src={ImgEmpezar} alt="Imagen-Ilustracion" className="img-empezar" />
      <div className="cards-empezar">
        <Card
          title={"Test"}
          description={
            "Selecciona el test a realizar e identifica señales tempranas o cambios en tu visón"
          }
           img={ImgTest}
          path={"/tests"}
          className={"opcion-test"}
        />
        <Card
          title={"Identifica el síntoma"}
          description={
            "Te guiaremos a la prueba más adecuada para obtener una primera orientación."
          }
           img={ImgSintomas}
          path={"/sintomas"}
          className={"opcion-sintomas"}
        />
      </div>
      <Button text={"Agendar Cita"} className="agendar-cita" onClick={handleAgendarCitaClick}/>
    </section>
  );
};

export default SectionEmpezar;
